import React from "react";
import { bool, func, number, string } from "prop-types";
import cx from "classnames";

import "./styles/style.scss";

import TabsStatic from "./Tabs.static";
import Tab from "./Tab";

export default class Tabs extends React.Component {
  static displayName = "Tabs";

  static propTypes = {
    /** Active Tab index */
    activeTabIndex: number,
    /** Additional classes for tabs header. */
    classesTabNav: string,
    /** Additional classes for tabs content. */
    classesTabPanelWrapper: string,
    /** If true, all tabs have equal width; their parent has full width */
    equalTabWidth: bool,
    /** On tab change callback function. */
    onChange: func,
  };

  static defaultProps = {
    activeTabIndex: 0,
    onChange: (activeTab, activeTabPanel, e) => {}, // eslint-disable-line no-unused-vars
  };

  componentDidMount() {
    this.tabs = new TabsStatic(this.tabListRef, {
      // eslint-disable-next-line react/destructuring-assignment
      onChange: this.props.onChange,
    });
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps() {
    // eslint-disable-next-line react/destructuring-assignment
    this.tabs.activateNthTab(this.props.activeTabIndex);
  }

  componentWillUnmount() {
    this.tabs.destroy();
  }

  getTabs = () => {
    const { children, activeTabIndex } = this.props;

    return children.map((tabPanel, i) => {
      if (!tabPanel.props.renderTab) {
        return React.createElement(
          Tab,
          {
            key: tabPanel.props.id,
            isDisabled: tabPanel.props.isDisabled,
            controls: tabPanel.props.id,
            isActive: i === activeTabIndex,
          },
          tabPanel.props.tab
        );
      }

      return React.cloneElement(tabPanel.props.renderTab(tabPanel.props), {
        key: tabPanel.props.id,
        isActive: i === activeTabIndex,
      });
    });
  };

  getPanels = () => {
    const { children, activeTabIndex } = this.props;

    return children.map((tabPanel, i) =>
      React.cloneElement(tabPanel, {
        key: `tabpanel-${tabPanel.props.id}`,
        isActive: i === activeTabIndex,
      })
    );
  };

  // TODO: move this to Tabs.static.js as static method with el as param
  // handleTabsHeaderScroll = () => {
  //   const el = this.tabsHeaderRef;
  //   let scrollPosition;
  //
  //   if (el.offsetWidth === el.scrollWidth) {
  //     scrollPosition = null;
  //   } else if (el.scrollLeft === 0) {
  //     scrollPosition = 'left';
  //   } else if (el.scrollWidth - el.offsetWidth <= el.scrollLeft + 1) {
  //     scrollPosition = 'right';
  //   } else {
  //     scrollPosition = 'middle';
  //   }
  //
  //   this.setState({
  //     headerScrollPosition: scrollPosition,
  //   });
  // };

  render() {
    const {
      activeTabIndex, // eslint-disable-line
      children,
      className,
      classesTabNav,
      classesTabPanelWrapper,
      equalTabWidth,
      ...other
    } = this.props;

    const CLASS_TABNAV = "tabnav";

    const tabNavClasses = cx(
      CLASS_TABNAV,
      { [`${CLASS_TABNAV}--equal`]: equalTabWidth },
      classesTabNav
    );

    const TabPanelWrapperClasses = cx("tab-panels", classesTabPanelWrapper);

    this.hasActiveTab = children.some((child) => child.props.isActive);

    return (
      <>
        <div
          key="tabnav"
          className={tabNavClasses}
          onScroll={this.handleTabsHeaderScroll}
          {...other}
        >
          <ul
            className={`${CLASS_TABNAV}__list`}
            role="tablist"
            ref={(c) => {
              this.tabListRef = c;
            }}
          >
            {this.getTabs()}
          </ul>
        </div>
        <div key="tabpanels" className={TabPanelWrapperClasses}>
          {this.getPanels()}
        </div>
      </>
    );
  }
}
